import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import router from "../router";



Vue.use(Vuex)


export default new Vuex.Store({
//function builder(data) {
	//return new Vuex.Store({
		state: {
			accessToken: null,
			user: null,
			authError: {
				mess: '',
				errors: {},
			},
			//accessToken: 'asdasd23r2rwfsdafaa',
			//user: {id: 2},
			videosInfo: [],
			tracks: [],
			streamsInfo: [],
			currentVideo: false,
			currentStream: false,
			doneInit: false,
			loadingVideos: true,
		},
		mutations: {
			setDoneInit(state, val) {
				state.doneInit = val
			},
			setVideosLoading(state, videosLoadingStatus) {
				state.loadingVideos = videosLoadingStatus
			},
			userLoginSuccess(state, userData) {
				state.accessToken = userData.accessToken
				state.user = userData.user
			},
			userLoginFail(state, error) {
				state.authError = error
			},
			userDisconnect(state) {
				state.accessToken = null
				state.user = null
			},
			setVideosInfo(state, videosInfo) {
				state.videosInfo = videosInfo
				let tracks = {
						'none': {
							'title': 'Recently Live',
							'videos': [],
						},
					}
					state.videosInfo.videos.forEach((item, index) => {
						if (item.tags.length == 0) {
							tracks.none.videos.push(item)
						}
						item.tags.forEach(tag => {
							if (!tracks.hasOwnProperty(tag)) tracks[tag] = { 'title': tag, 'videos': [] }
							tracks[tag].videos.push(item)
						})
					});
				state.tracks = tracks

			},
			setStreamsInfo(state, streamInfo) {
				streamInfo.streaming_events.sort((a, b) => a.scheduled_start_time - b.scheduled_start_time)
				state.streamsInfo = streamInfo
			},
			setCurrentVideo(state, [trackIndex, itemIndex]) {
				state.currentVideo = state.tracks[trackIndex].videos[itemIndex]
			},
			setCurrentStream(state, itemIndex) {
				state.currentStream = state.streamsInfo.streaming_events[itemIndex]
			},
		},
		actions: {
			init({ dispatch, commit, state }, initData) {
				//console.log(state)
				//await dispatch('autoLogin')
				//dispatch('getVideos')
				//dispatch('getStream')
				//let autoLogin = dispatch('autoLogin');
				//let getVideos = dispatch('getVideos');
				//let getStream = dispatch('getStream');

				/*await dispatch('autoLogin');
				console.log('1')
				commit('setLoading', false)*/


				return new Promise((resolve, reject) => {
					dispatch('autoLogin');
					//commit('setLoading', false)
					commit('setDoneInit', true)
					resolve()
				});
				/*return Promise.all([promise1, getVideos, getStream])
					.then((values) => {
						console.log('all done')
						console.log(values)
						commit('setLoading', false)
				});*/
			},
			async getAllVideos({ dispatch, commit, state }) {
				commit('setVideosLoading', true)
				//await dispatch('getVideos');
				await axios.get('https://icej-jhop.frb.io/api/get-videos', {
					headers: {
						Authorization: `Bearer ${state.accessToken}`
					}
				}).then(result => {
					//console.log(result.data)
					commit('setVideosInfo', result.data)
				}).catch(error => console.log(error))

				//await new Promise(resolve => setTimeout(resolve, 5000));

				//await dispatch('getStream');
				await axios.get(' https://icej-jhop.frb.io/api/get-streaming-events', {
					headers: {
						Authorization: `Bearer ${state.accessToken}`
					}
				}).then(result => {
					//console.log(result.data)
					commit('setStreamsInfo', result.data)
				}).catch(error => console.log(error))

				//console.log('4')
				commit('setVideosLoading', false)
			},

			/*async getVideos({ commit, state }) {
				await axios.get('https://icej-jhop.frb.io/api/get-videos', {
					headers: {
						Authorization: `Bearer ${state.accessToken}`
					}
				}).then(result => {
					//console.log(result.data)
					commit('setVideosInfo', result.data)
				}).catch(error => console.log(error))
			},
			async getStream({ commit, state }) {
				await axios.get(' https://icej-jhop.frb.io/api/get-streaming-events', {
					headers: {
						Authorization: `Bearer ${state.accessToken}`
					}
				}).then(result => {
					//console.log(result.data)
					commit('setStreamsInfo', result.data)
				}).catch(error => console.log(error))
			},*/
			signup({ commit }, authData) {
				axios.post('https://icej-jhop.frb.io/api/register', {
					email: authData.email,
					password: authData.password,
				}).then(result => {
					localStorage.setItem('accessToken', result.data.idToken)
					localStorage.setItem('user', result.data.localId)
					commit('userLoginSuccess', {
						token: result.data.idToken,
						userId: result.data.localId
					})
				}).catch(error => console.log(error))
			},
			login({ commit }, authData) {
				axios.post('https://icej-jhop.frb.io/api/login', {
					email: authData.email,
					password: authData.password,
				}).then(result => {
					//console.log(result)
					if (!result.data.hasOwnProperty('message')) {
						localStorage.setItem('accessToken', result.data.access_token)
						localStorage.setItem('user', JSON.stringify(result.data.user))
						commit('userLoginSuccess', {
							accessToken: result.data.access_token,
							user: result.data.user
						})
						router.push("/videos")
					} else {
						commit('userLoginFail', {
							mess: result.data.message,
							errors: result.data.hasOwnProperty('errors') ? result.data.errors : {},
						})
					}
				}).catch(error => {
					if (error.response.data.message.length != 0) {
						commit('userLoginFail', {
							mess: error.response.data.message,
							errors: error.response.data.hasOwnProperty('errors') ? error.response.data.errors : {},
						})
					}
				})
			},
			logout({ commit }) {
				commit('userDisconnect')
				localStorage.removeItem('accessToken')
				localStorage.removeItem('user')
				//console.log(localStorage.getItem('accessToken'))
				router.push("/")
			},
			async autoLogin({ commit }, videosJson) {
				/*commit('setVideosInfo', {
					videosInfo: videosJson
				})*/
				const accessToken = localStorage.getItem('accessToken')
				if (!accessToken) { return }
				const user = JSON.parse(localStorage.getItem('user'))
				commit('userLoginSuccess', {
					accessToken: accessToken,
					user: user
				})
			},
			/*fetchVideosInfo({ commit }) {
				commit('setVideosInfo', {
					videosInfo: videosJson
				})
			},*/
			playItem({ commit }, [trackIndex, itemIndex]) {
				trackIndex = (trackIndex == 'Recently Live') ? 'none' : trackIndex;
				commit('setCurrentVideo', [trackIndex, itemIndex])
			},
			playStream({ commit }, [itemIndex]) {
				commit('setCurrentStream', itemIndex)
			},
		},
		getters: {
			doneInit(state) {
				return state.doneInit
			},
			loadingVideos(state) {
				return state.loadingVideos
			},
			authError(state) {
				return state.authError
			},
			userInfo(state) {
				return (state.accessToken !== null) ? state.user : false
			},
			isLoggedUser(state) {
				return state.accessToken !== null
			},
			videosLists(state) {
				return state.tracks
				/*if (state.videosInfo.length == 0) {
					return []
				} else {
					let tracks = { 'none': {
						'title': 'None',
						'videos': [],
					}, }
					state.videosInfo.videos.forEach((item, index) => {
						if (item.tags.length == 0) {
							tracks.none.videos.push(item)
						}
						item.tags.forEach(tag => {
							if (!tracks.hasOwnProperty(tag)) tracks[tag] = {'title': tag, 'videos': []}
							tracks[tag].videos.push(item)
						})
					});
					return tracks
					return state.videosInfo.videos
				}*/
			},
			streams(state) {
				if (state.streamsInfo.length == 0) {
					return []
				} else {
					return state.streamsInfo.streaming_events
				}
			},
			activeStream(state) {
				if (state.streamsInfo.length == 0) {
					return false
				} else {
					//return state.streamsInfo.streaming_events.find(item => item.active)
					var output = state.streamsInfo.streaming_events.find(item => item.active);
					if (output === undefined) {
						output = state.streamsInfo.streaming_events[0];
					}
					return output;
				}
			},
			currentVideo(state) {
				return state.currentVideo
			},
			currentStream(state) {
				return state.currentStream
			},

		}
	})
//}
//export default builder
